var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 201 201"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes scaleUp{0%,to{transform:scale(1)}50%{transform:scale(.1)}}@keyframes scaleDown{0%,to{transform:scale(.1)}50%{transform:scale(1)}}.loading_svg__sparkle{transform-origin:center;transform-box:fill-box;animation-duration:1.2s;animation-timing-function:ease-in-out;animation-iteration-count:infinite;opacity:1}")), /*#__PURE__*/React.createElement("path", {
    fill: "url(#loading_svg__paint0_linear_2317_26340)",
    d: "M150.658 113.103c-33.475 2.019-60.263 28.807-62.282 62.282h-.244c-2.019-33.475-28.806-60.263-62.28-62.282v-.244c33.474-2.019 60.261-28.807 62.28-62.282h.244c2.02 33.475 28.807 60.263 62.282 62.282z",
    className: "loading_svg__sparkle",
    style: {
      animationDelay: "0s",
      animationName: "scaleUp"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#loading_svg__paint1_linear_2317_26340)",
    d: "M175.813 60.331c-18.788 1.133-33.822 16.168-34.955 34.956h-.138c-1.133-18.788-16.167-33.823-34.954-34.956v-.137c18.787-1.133 33.821-16.167 34.954-34.955h.138c1.133 18.788 16.167 33.822 34.955 34.955z",
    className: "loading_svg__sparkle",
    style: {
      animationDelay: ".2s",
      animationName: "scaleDown"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "loading_svg__paint0_linear_2317_26340",
    x1: 108.507,
    x2: 69.731,
    y1: 94.731,
    y2: 134.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DBCEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DA3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "loading_svg__paint1_linear_2317_26340",
    x1: 152.114,
    x2: 132.125,
    y1: 49.437,
    y2: 72.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DD7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DCAE6"
  })))));
};
export default SvgLoading;